import React from 'react';
import { BusinessUnitSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/BusinessUnitSelect';
import { EntitySelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/EntitySelect';
import { RetailerSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/RetailerSelect';
import { SegmentSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/SegmentSelect';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import WeekRangeSelect from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/WeekRangeSelect';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { CategoryAndSubcategorySelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/CategoryAndSubcategorySelect';

export const PresentationsSelectionPage = () => {
  const {
    selections: { watch }
  } = usePresentationFormContext();

  const entityType = watch('entityType');

  const entityTypeComponent = {
    category: () => <CategoryAndSubcategorySelect />,
    segment: () => <SegmentSelect />,
    businessunit: () => <BusinessUnitSelect />
  };

  return (
    <Flex gap={64} flexDirection="column">
      <WeekRangeSelect />
      <EntitySelect />
      <RetailerSelect />
      {entityTypeComponent[entityType.id]()}
    </Flex>
  );
};
